import axios from "axios";
const CONTROLLER_PATH = "SubscribeFormSubmission";
class SubscribeFormSubmissionService {
    //CREATE
    create(entity) {
        return axios.post(CONTROLLER_PATH, entity).then((response) => response.data);
    }
    submission(formData) {
        return axios
            .post(CONTROLLER_PATH + "/submission", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }
    validitycheck(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/subscribeformvaliditycheck", { params: urlParameters }).then((response) => response.data);
    }

    //UPDATE
    update(entity) {
        return axios.put(CONTROLLER_PATH + "/" + entity.id, entity).then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }
}

export default new SubscribeFormSubmissionService();
